import styled from 'styled-components'

export const Container = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  padding: 0.7rem;
  width: 330px;
  margin-left: 1rem;
  height: 190px;
  top: 0px;
  background: ${({ theme }) => `rgb(${theme.component.background})`};
  border: ${({ theme }) => `1px solid rgb(${theme.grayscale[400]})`};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;

  h2 {
    font-size: 0.9rem;
    line-height: 1.5625rem;
    height: 6rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]}, 0.9)`};
    max-width: 27rem;
    display: -webkit-box;
    -webkit-line-clamp: 7;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    line-height: 1.4rem;
  }
  span {
    font-size: 0.8rem;
    line-height: 1rem;
    font-weight: 700;
    color: ${({ theme }) => `rgba(${theme.grayscale[200]}, 0.9)`};
    margin-left: 0.3rem;
  }

  img {
    margin-top: 1rem;
    height: 4rem;
    max-width: 5rem;

    background-color: #fff;
    border-radius: 5px;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  span {
    color: #0f9c91;
    padding: 0.2rem 0.72rem;
    border-radius: 3px;
    //background: rgba(127, 209, 203, 0.5);
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 700;

    b {
      font-size: 1rem;
      line-height: 1.25rem;
      font-weight: 600;
    }
  }
`

export const TextContainer = styled.div`
  margin-left: 1rem;

  svg {
    color: ${({ theme }) => `rgba(${theme.grayscale[200]}, 0.9)`};
  }
`
